"use client"

import SegmentError from "@/modules/common/components/segment-error"

// Keeps the main layout and the cart when a page or checkout step fails to load (25 Sep 2026, BOO 3840c13 parity).
export default function Error({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  return <SegmentError error={error} reset={reset} where="main" />
}
